// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取签署模板列表 GET /api/template_sign */
export async function getTemplateSignList(
    params?: TemplateSignAPI.TemplateSignListParams,
    options?: { [key: string]: any },
) {
    return request<API.PagingResponse<TemplateSignAPI.TemplateSignVO>>(
        '/api/template_sign',
        {
            method: 'GET',
            params: {
                page: params?.current,
                limit: params?.pageSize,
                ...params,
            },
            ...(options || {}),
        },
    );
}

/** 获取签署模板详情 GET /api/template_sign/:id */
export async function getTemplateSignDetail(
    id: number,
    options?: { [key: string]: any },
) {
    return request<API.Response<TemplateSignAPI.TemplateSignVO>>(
        `/api/template_sign/${id}`,
        {
            method: 'GET',
            ...(options || {}),
        },
    );
}

/** 创建签署模板 POST /api/template_sign/ */
export async function createTemplateSign(
    data: TemplateSignAPI.TemplateSignCreateParams,
    options?: { [key: string]: any },
) {
    return request<API.Response<any>>('/api/template_sign/', {
        method: 'POST',
        data,
        ...(options || {}),
    });
}

/** 更新签署模板 PUT /api/template_sign/:id */
export async function updateTemplateSign(
    id: number,
    data: TemplateSignAPI.TemplateSignUpdateParams,
    options?: { [key: string]: any },
) {
    return request<API.Response<any>>(`/api/template_sign/${id}`, {
        method: 'PUT',
        data,
        ...(options || {}),
    });
}

/** 删除签署模板 DELETE /api/template_sign/ */
export async function deleteTemplateSign(
    ids: number[],
    options?: { [key: string]: any },
) {
    return request<API.Response<any>>('/api/template_sign/', {
        method: 'DELETE',
        data: {
            ids,
        },
        ...(options || {}),
    });
}

/** 克隆签署模板 */
export async function cloneTemplateSign(
    id: number,
    data: {
        name: string;
        desc?: string;
        valid_duration: number;
    },
    options?: { [key: string]: any },
) {
    return request<API.Response<any>>(`/api/template_sign/${id}/clone`, {
        method: 'POST',
        data,
        ...(options || {}),
    });
}

/** 发布签署模板（预留） */
export async function publishTemplateSign(
    id: number,
    options?: { [key: string]: any },
) {
    return request<API.Response<any>>(`/api/template_sign/${id}/publish`, {
        method: 'POST',
        ...(options || {}),
    });
}
